import React, { Fragment, useState, useEffect, useRef } from "react";
import { Redirect, useNavigation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import loading from "../components/loading.json";
import { themeStyle, themeStyleDark } from "../components/Components";
import Backdrop from "@mui/material/Backdrop";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Grid } from "@mui/material";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import VisitUs from "../components/VisitUs";
import CountUp from "react-countup";
import axios from "axios";
import { API_URL } from "../actions/auth";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import "react-quill/dist/quill.snow.css";

import {
  useSpringCarousel,
  useTransitionCarousel,
} from "react-spring-carousel";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import { useInView, useSpring, animated, useScroll } from "@react-spring/web";

export default function Case() {
  const state = useSelector((state) => state);
  const [news, setNews] = useState([
    { image: "", title: "", subtitle: "" },
    { image: "", title: "", subtitle: "" },
    { image: "", title: "", subtitle: "" },
    { image: "", title: "", subtitle: "" },
  ]);
  const dispatch = useDispatch();

  const [zoom1, zoom1api] = useSpring(() => ({
    from: { transform: "scale(1)" },
  }));

  const [zoom2, zoom2api] = useSpring(() => ({
    from: { transform: "scale(1)" },
  }));
  const [isLoading, setIsLoading] = useState(false);
  const [category, setCategory] = useState("Digital Marketing");

  const [segments, setSegments] = useState(["All"]);
  const [selectedSegment, setSelectedSegment] = useState("All");

  const [caseStudies, setCaseStudies] = useState([{ title: "Loading" }]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(API_URL + "get_all_case_studies")
      .then((res) => {
        console.log(res.data);
        setCaseStudies(res.data["case_studies"]);
        setSegments(res.data["segments"]);
        setIsLoading(false);
      })
      .catch((err) => {});
  }, []);

  function getContent() {
    return (
      <div className="main">
        <Sidebar />

        <div className="anigrad">
          <div
            style={{
              height: "90vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "75vw",
                marginLeft: state.auth.isMobile ? "25px" : "0px",
              }}
            >
              <div
                style={{
                  fontSize: state.auth.isMobile ? "70px" : "100px",
                  color: "yellow",
                  zIndex: 999,
                  textAlign: state.auth.isMobile ? "center" : "left",
                }}
              >
                Our Work
              </div>
              <div
                style={{
                  borderBottom: "2px solid white",
                  width: "100%",
                  margin: "25px 0px 25px 0px",
                }}
              ></div>
              <div
                style={{
                  fontSize: state.auth.isMobile ? "30px" : "4.4vh",
                  color: "white",
                  zIndex: 999,
                }}
              >
                News and insights on all things by Riches Media Digital
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            padding: state.auth.isMobile ? "10px" : "100px",
            marginBottom: "-100px",
          }}
        >
          <div
            style={{
              fontSize: "8.75vh",
              color: "white",
              zIndex: 999,
              marginBottom: "25px",
              textAlign: "left",
            }}
          >
            Our Work
          </div>
        </div>
        <div
          style={{
            maxWidth: "100vw",
            padding: state.auth.isMobile ? "10px" : "10vh",
            marginBottom: state.auth.isMobile ? "100px" : "0px",
          }}
        >
          <Grid container>
            {caseStudies.map((caseStudy, index) => (
              <Grid
                item
                xs={12}
                md={4}
                style={{
                  cursor: "pointer",
                  marginTop: "10px",
                  marginLeft: state.auth.isMobile ? "-15px" : "0px",
                  padding: "10px 10px 0px 10px",
                  width: "100%",
                  height: state.auth.isMobile ? "26vh" : "32vh",
                  zIndex: 100,
                  textAlign: "left",
                  marginBottom: "100px",
                }}
              >
                <Link
                  to={"/casestudies/" + caseStudy.slug + "/"}
                  params={{ slug: caseStudy.slug }}
                  style={{
                    cursor: "pointer",
                    textDecoration: "none",
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      margin: "15px",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundImage:
                        "url('" +
                        API_URL +
                        "media/" +
                        caseStudy.post_id +
                        ".jpg')",
                      borderRadius: 10,
                    }}
                  ></div>
                  <div
                    style={{
                      fontSize: "3.6vh",
                      marginLeft: "15px",
                      color: "black",
                      fontWeight: "bold",
                    }}
                  ></div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                      marginLeft: "15px",
                      color: "white",
                    }}
                  >
                    {caseStudy.title}
                  </div>
                </Link>
              </Grid>
            ))}
          </Grid>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
